import axios from './axios.interceptors';

export interface FlightRouteDestination {
    origin: string;
    city_name?: string;
    country_name?: string;
    days_of_week?: string;
    destination: string;
    destination_name?: string;
    arrival_Country?: string;
    effective_start?: string;
    effective_end?: string;
}

export interface RouteByCountryItem {
    countryName: string;
    flightRoute: Array<{
        origin: string;
        days_of_week: string;
        destination: string;
        effective_start: string;
        effective_end: string;
    }>;
}

class CountriesService {
    public getAirports = async (): Promise<any[]> => {
        try {
            const response = await axios.get('/api/v1/countries/airports');
            return response.data;
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    public getRoutesByCountry = async (): Promise<RouteByCountryItem[]> => {
        try {
            const response = await axios.get('api/flights/routes-by-country');
            const data = response.data;

            if (Array.isArray(data)) return data;
            if (Array.isArray(data?.value)) return data.value;

            return [];
        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    public getFlightRoutes = async (origin: string): Promise<FlightRouteDestination[]> => {
        try {
            const normalizedOrigin = String(origin || '').trim().toUpperCase();
            const response = await axios.get(
                `/api/v1/flights/routes?origin=${encodeURIComponent(normalizedOrigin)}`
            );
            const data = response.data;

            if (Array.isArray(data)) return data;
            if (Array.isArray(data?.value)) return data.value;

            return [];
        } catch (err) {
            console.log(err);
            throw err;
        }
    }
}

export default new CountriesService();
